import React from 'react'
import ViewAcademicMembersForm from '../../features/viewAcademicMember/ViewAcademicMembersForm'

const ViewAcademicMembers = () => {
  return (
    <div><ViewAcademicMembersForm /> </div>
  )
}

export default ViewAcademicMembers